module.exports = __webpack_public_path__ + "img/ren.5c0c9cc2.jpg";